import React from 'react';

//Retorna el ícono del Logo de LPChat.
const IconComponent = () => {
  const iconStyle = {
    width: "60px",
    height: "100%",
    display: "flex",
    alignItems: "center",
  };

  return (
    <div style={iconStyle}>


      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="40px"
        height="40px"
        viewBox="0 0 57 55"  // Definir el área de visualización
        preserveAspectRatio="xMidYMid meet" // Centrar horizontal y verticalmente el contenido
      >
        <path
          d="M0 0 C6.09436367 4.67367323 9.39609459 10.80836509 10.3984375 18.37890625 C10.74842875 27.75299633 9.38949875 34.72548761 3.0859375 41.80859375 C-3.87277781 48.41045186 -10.52559639 50.34257267 -20.03515625 50.11328125 C-25.56368559 49.45411044 -31.0907889 47.74124235 -35.08203125 43.75 C-37.51455786 43.28837573 -37.51455786 43.28837573 -40.20703125 43.125 C-41.11710937 43.05023438 -42.0271875 42.97546875 -42.96484375 42.8984375 C-43.66351563 42.84945312 -44.3621875 42.80046875 -45.08203125 42.75 C-46.26494285 38.84639173 -45.74586427 36.62517662 -44.484375 32.82421875 C-43.97855 30.21651897 -44.29226071 28.06655063 -44.64453125 25.4375 C-45.49156717 17.89681435 -43.72622082 11.79808353 -39.51953125 5.5 C-29.2321275 -7.17922512 -13.42259502 -8.05859363 0 0 Z "
          fill="var(--color-degraded-by-company)"
          transform="translate(47.08203125,5.25)"
        />
        <path
          d="M0 0 C-0.79664062 0.32871094 -1.59328125 0.65742187 -2.4140625 0.99609375 C-11.14710529 4.91640128 -15.14828321 8.87517872 -19.13671875 17.44140625 C-20.08316005 20.24646982 -20.23402828 22.42256925 -20.1875 25.375 C-20.17589844 26.33664063 -20.16429687 27.29828125 -20.15234375 28.2890625 C-20.05298795 31.19262556 -20.05298795 31.19262556 -19.25 34.75 C-18.89893705 39.31381832 -20.47596721 41.25219374 -23 45 C-24.37782302 41.55544244 -23.51552203 39.51439091 -22.40234375 36.109375 C-21.90202651 33.48635258 -22.20786025 31.33049937 -22.5625 28.6875 C-23.40953592 21.14681435 -21.64418957 15.04808353 -17.4375 8.75 C-13.45126535 3.84463355 -6.61545398 -2.54557791 0 0 Z "
          fill="var(--color-by-company)"
          transform="translate(25,2)"
        />
        <path
          d="M0 0 C5 0 18 0 23 0 C23 1 23 2 23 3 C18 3 5 3 0 3 C0 2 0 1 0 0 Z"
          fill="#EBF3F3"
          transform="translate(19,20)"
        />
        <path
          d="M0 0 C5 0 18 0 23 0 C23 1 23 2 23 3 C18 3 5 3 0 3 C0 2 0 1 0 0 Z"
          fill="#EBF3F3"
          transform="translate(19,25.7)"
        />
        <path
          d="M0 0 C7 0 21 0 28 0 C28 0.5 28 1.5 28 3 C21 3 7 3 0 3 C0 1.5 0 0.5 0 0 Z"
          fill="#F9FCFC"
          transform="translate(19,32)"
        />
      </svg>

    </div>
  );
};

export default IconComponent;
